// Public Scripts

/**
 * Handles reveal and scroll behavior for sections on the page.
 */
window.jsRevealer = function () {
    const OFFSET = -80;

    function revealAndScrollTo(target, forceReveal = false) {
        if (!target.classList.contains("js-reveal-section")) return;

        const isCollapsed = target.classList.contains("is-collapsed");

        if (forceReveal) {
            if (isCollapsed) {
                target.classList.remove("is-collapsed");
            }
        } else {
            target.classList.toggle("is-collapsed");
        }

        if (!target.classList.contains("is-collapsed")) {
            const top = target.getBoundingClientRect().top + window.scrollY + OFFSET;

            window.scrollTo({
                top,
                behavior: "smooth"
            });
        }
    }

    function handleHashChange() {
        const hash = window.location.hash;
        if (!hash || hash.length < 2) return;

        const target = document.querySelector(hash);

        if (target && target.classList.contains("js-reveal-section")) {
            revealAndScrollTo(target, true);
        }
    }

    document.querySelectorAll(".js-reveal-trigger").forEach(function (trigger) {
        if (trigger.dataset.jsRevealerBound === "true") return;

        trigger.dataset.jsRevealerBound = "true";

        trigger.addEventListener("click", function (e) {
            e.preventDefault();

            const link = trigger.closest('a[href^="#"]') || trigger.querySelector('a[href^="#"]');
            if (!link) return;

            const href = link.getAttribute("href");
            if (!href || href === "#" || !href.startsWith("#") || href.length < 2) return;

            const target = document.querySelector(href);

            if (target && target.classList.contains("js-reveal-section")) {
                revealAndScrollTo(target);
                history.pushState(null, "", href);
            }
        });
    });

    handleHashChange();

    if (!window.jsRevealerHashChangeBound) {
        window.addEventListener("hashchange", handleHashChange);
        window.jsRevealerHashChangeBound = true;
    }
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", window.jsRevealer);
} else {
    window.jsRevealer();
}